import { jsx as _jsx } from "react/jsx-runtime";
import { HoursEditor } from './HoursEditor';
export const EditHour = (props) => _jsx(HoursEditor, { ...props, mode: 'day' });
